// extracted by mini-css-extract-plugin
export default {"imageContainer":"K3-z","summaryPar":"L3-z","ratingCategories":"M3-z","reviewerInfo":"N3-z","reviewTypes":"O3-z","expanded":"P3-z"};